var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thirdDetail"},[_c('common-detail',{attrs:{"thirdParty":"","hasPhone":"","title":_vm.detail.serviceName,"imgList":_vm.detail.servicePictures,"phoneNumber":_vm.detail.phone}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }